import { ChangeEvent, FormEvent, useEffect, useState } from "react"
import FAQForm from "./components/FAQForm"
import { FaqInput, FaqInputError, FaqProps, FaqUpdateInput } from "../state/actionType"
import { ApiError } from "components";
import { connect, useSelector } from "react-redux";
import { updateFaq } from "../state/action";

interface HandlerUpdateFAQProps {
    closeModal: React.Dispatch<React.SetStateAction<boolean>>;
    faqData?: FaqProps
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & HandlerUpdateFAQProps;
const HandlerUpdateFAQ: React.FC<Props> = ({closeModal, faqData, onUpdateFaq}) => {
    const [formData, setFormData] = useState<FaqInput>({
        question: faqData?.question || "",
        answer: faqData?.answer || "",
    })
    const faqState = useSelector((state: any) => state.faq.genericFaqState);

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<FaqInputError>({});
  const [apiError, setApiError] = useState(null);
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    if (formData.answer.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        name: "Package Name is required",
      }));
    }

    if (formData.question.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        description: "Package Description is required",
      }));
    }

    if (formData.answer.trim() !== "" && formData.question.trim() !== "") {
      setSubmitted(true);
      setLoading(true);
      try {
        const input:FaqUpdateInput = {
            answer:formData.answer,
            question:formData.question,
            id:faqData?.id?.toString() ? faqData?.id?.toString(): ""
        }
        await onUpdateFaq(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (!faqState.isLoading && submitted) {
      if (faqState.error) {
        setApiError(faqState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [faqState.isLoading, faqState.error, submitted]);
    return(
        <>
      <FAQForm
        handleChange={handleChange}
        handleSave={handleSave}
        loading={loading}
        error={error}
        formData={formData}
        header="Create FAQ"
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
    )
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateFaq: (input: FaqUpdateInput) => dispatch(updateFaq(input)),
});
export default connect(null, mapDispatchToProps)(HandlerUpdateFAQ);